import { inject, observer } from "mobx-react";
import { baseUrl } from "stores/main";
import photo from "./images/photo.svg";
import photoPerson from "./images/photoPerson.svg";

import "./foto.scss";

const Foto = ({ deleteFile, sendAgentFile, userData, userFiles }) => {
  return (
    <div className="myprofile__photo">
      {userFiles?.["avatar"] && userFiles["avatar"] !== -1 ? (
        <>
          <div className="myprofile__photo-img-wrapper">
            <img
              className="myprofile__photo-personimg"
              src={`${baseUrl}${userFiles["avatar"]}?${Math.floor(
                Math.random() * 100000
              )}`}
              alt=""
            />
          </div>
          <div className="myprofile__photo-string-wrapper">
            <div
              className="myprofile__photo-string"
              onClick={(e) => {
                e.preventDefault();
                Promise.all([
                  deleteFile({
                    id: userData["id"],
                    file_name: "avatar"
                  })
                ]);
              }}
            >
              <img src={photo} className="myprofile__photo-string-img" alt="" />
              <p className="myprofile__photo-string-subtitle" type="file">
                Удалить фото
              </p>
            </div>
          </div>
        </>
      ) : (
        <>
          <img className="myprofile__photo-img" src={photoPerson} alt="" />
          <div className="myprofile__photo-string-wrapper">
            <label htmlFor="img-input" className="myprofile__photo-string">
              <img src={photo} className="myprofile__photo-string-img" alt="" />
              <p className="myprofile__photo-string-subtitle" type="file">
                Загрузить фото
              </p>
            </label>

            <input
              id="img-input"
              type="file"
              onChange={(e) => {
                e.preventDefault();
                Promise.all([
                  sendAgentFile({
                    id: userData["id"],
                    file_name: "avatar",
                    file: e.target.files[0]
                  })
                ]);
              }}
              className="myprofile__photo-string-img-input"
            />
          </div>
        </>
      )}
      <div className="myprofile__photo-string-id">
        ID: <p> {userData["number"]}</p>
      </div>
    </div>
  );
};

export default inject(({ usersStore, filesStore }) => {
  const { deleteFile, sendAgentFile } = filesStore;
  const { userData } = usersStore;

  return {
    deleteFile,
    sendAgentFile,
    userData
  };
})(observer(Foto));
